module.exports = __webpack_public_path__ + "img/Body_feathers_MetalRoughness.2e2a599.jpg";